import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";

export const Orbit = ({ className = "mx-auto" }) => {
  const satelliteRef = useRef(null);

  useGSAP(() => {
    const satellite = satelliteRef.current;
    if (!satellite) return;

    // center the satellite's transform origin
    gsap.set(satellite, {
      xPercent: -165,
      yPercent: -165,
      transformOrigin: "50% 50%",
    });

    // Create the main orbit timeline
    const tl = gsap.timeline({
      repeat: -1,
      ease: "none",
      onUpdate: () => {
        const progress = tl.progress();
        if (progress >= 0 && progress <= 0.1) {
          gsap.to(satellite, {
            ease: "none",
            scale: 1 - (0.4 - progress),
          });
        } else if (progress > 0.1 && progress <= 0.4) {
          gsap.to(satellite, {
            ease: "none",
            scale: 1 + (0.4 - progress),
          });
        } else if (progress > 0.4 && progress <= 1) {
          gsap.to(satellite, {
            ease: "none",
            scale: 1 + (0.1 - progress),
          });
        } else {
          gsap.to(satellite, {
            ease: "none",
            scale: 1 - Math.abs(0.5 - progress),
          });
        }
      },
    });

    tl.to(satellite, {
      duration: 7,
      motionPath: {
        path: "#orbit-path",
        autoRotate: false,
      },
    });
  });

  return (
    <svg
      id="orbit-animation"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="120 155 190 155"
      height={150}
      width={150}
      className={className}
      style={{ overflow: "visible" }}
    >
      <defs>
        <linearGradient
          id="paint0_linear_6208_23"
          x1="76.35"
          y1="175.23"
          x2="98.57"
          y2="14.3101"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D2949"></stop>
          <stop offset="1" stopColor="#52B773"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_6208_23"
          x1="7.45296"
          y1="100.357"
          x2="193.863"
          y2="100.357"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F89C6B"></stop>
          <stop offset="1" stopColor="#CDCD81"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_6208_23"
          x1="96.72"
          y1="178.04"
          x2="118.94"
          y2="17.1201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D2949"></stop>
          <stop offset="1" stopColor="#52B773"></stop>
        </linearGradient>
      </defs>

      <g transform="matrix(1, 0, 0, 1, 113.037666, 134.356018)">
        {/* Large planet */}
        <path
          d="M87.73 171.58C131.222 171.58 166.48 136.323 166.48 92.8301C166.48 49.3377 131.222 14.0801 87.73 14.0801C44.2376 14.0801 8.98 49.3377 8.98 92.8301C8.98 136.323 44.2376 171.58 87.73 171.58Z"
          fill="url(#paint0_linear_6208_23)"
        />

        {/* Orbit path */}
        <path
          id="orbit-path"
          d="M124.507 125.775C172.625 80.6687 200.961 32.7193 187.797 18.6773C174.634 4.63526 124.956 29.818 76.8384 74.9246C28.7207 120.031 0.384608 167.98 13.5479 182.023C26.7112 196.065 76.3893 170.882 124.507 125.775Z"
          stroke="url(#paint1_linear_6208_23)"
          strokeWidth="5.7"
          strokeMiterlimit="10"
          style={{ fill: "rgba(0, 0, 0, 0)" }}
        />

        {/* Satellite - orbiting circle */}
        <path
          ref={satelliteRef}
          d="M89.96 82.2699C102.906 82.2699 113.4 71.7755 113.4 58.8299C113.4 45.8843 102.906 35.3899 89.96 35.3899C77.0144 35.3899 66.52 45.8843 66.52 58.8299C66.52 71.7755 77.0144 82.2699 89.96 82.2699Z"
          fill="#0D2949"
        />

        {/* Optional orbital trail */}
        <path
          d="M155.71 53.05C174.44 84.99 168.51 126.73 139.64 152.04C111.29 176.9 70.12 177.75 40.98 156.22"
          fill="url(#paint2_linear_6208_23)"
        />
      </g>
    </svg>
  );
};
